/** Цвета типов смен: бэкенд color не валидирует, поэтому нормализация на нашей стороне. */

export const DEFAULT_SHIFT_COLOR = "#e0e0e0"

/** Принимает "#rgb"/"#rrggbb" с решёткой или без; всё остальное — серый дефолт. */
export const normalizeHex = (color: string | undefined): string => {
  if (!color) return DEFAULT_SHIFT_COLOR
  const m = /^#?([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.exec(color.trim())
  if (!m) return DEFAULT_SHIFT_COLOR
  let hex = m[1]
  if (hex.length === 3) {
    hex = hex
      .split("")
      .map((c) => c + c)
      .join("")
  }
  return `#${hex.toLowerCase()}`
}

/** Чёрный или белый текст по относительной яркости WCAG (порог 0.179). */
export const readableTextColor = (bgColor: string): "#000000" | "#FFFFFF" => {
  const hex = normalizeHex(bgColor).slice(1)
  const r = parseInt(hex.slice(0, 2), 16) / 255
  const g = parseInt(hex.slice(2, 4), 16) / 255
  const b = parseInt(hex.slice(4, 6), 16) / 255
  const linear = (c: number) =>
    c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4)
  const luminance = 0.2126 * linear(r) + 0.7152 * linear(g) + 0.0722 * linear(b)
  return luminance > 0.179 ? "#000000" : "#FFFFFF"
}
